/*
派发事件列表
 * @Author: zj 
 * @Date: 2019-04-17 14:54:07 
 * @Last Modified by: mikey.zhaopeng
 * @Last Modified time: 2019-08-20 15:28:14
 */

const event_key = {

    /** 
     * @ 样例
     * @ demo key
     * @ 该注释不能省略 请在此处说明功能
     */
    TEST: 'TEST',

    /** 
     * @ 更新通讯录左侧和下级部门数据
     * @ UPDATA_TERR
     */
    UPDATA_TERR: 'UPDATA_TERR',

    /** 
     * @ 显示隐藏添加加部门弹窗
     * @ UPDATA_TERR
     */
    ADD_DEPA_POP: 'ADD_DEPA_POP',

    /** 
     * @ 显示隐藏多选部门弹窗
     * @ UPDATA_TERR
     */
    SELECT_DEPA_POP: 'SELECT_DEPA_POP',

    /** 
     * @ 配置工具返回切换
     * @ UPDATA_TERR
     */
    TOOL_BACK: 'TOOL_BACK',

    /** 
     * @ 用户组搜索事件
     * @ UPDATA_TERR
     */
    GROUP_SEARCH: 'GROUP_SEARCH',

    /** 
     * @ 内部通讯录通用事件
     * @ UPDATA_TERR
     */
    UPDATA_DEPA_INDEX: 'UPDATA_DEPA_INDEX',

    /** 
     * @ 公司详情更新
     * @ UPDATA_TERR
     */
    UPDATA_COMPANYINFO: 'UPDATA_COMPANYINFO',

    /** 
     * @ 监听问题详情更新
     * @ UPDATA_TERR
     */
    UPDATA_REPORTDETAIL: 'UPDATA_REPORTDETAIL',


    /** 
     * @ 取得消息列表
     * @ UPDATA_TERR
     */
    GET_MESSAGE: 'GET_MESSAGE',

    /** 
     * @ 首页数据更新
     * @ UPDATE_INDEX
     */
    UPDATE_INDEX: 'UPDATE_INDEX',

    /** 
     * @ 全局点击事件
     * @ OVERALL
     */
    OVERALL: 'OVERALL'

};

export default event_key


// WEBPACK FOOTER //
// ./src/communal/eventHub/IEventHub.js